import { Component, OnInit, ElementRef, ViewChild, HostListener } from '@angular/core';
import { DialogModalService } from './shared/dialog-modal/dialog-modal.service';
import { DialogButtons, DialogParams, DialogResult } from './shared/dialog-modal/dialog-types';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Location } from '@angular/common';
import { select, Store } from '@ngrx/store';
import { EnterKeyService } from './services/enter-key.service';
import { AppConfigService } from 'src/app/helpers/app-init-config.service';
import { selectedLoading } from 'src/app/store/selectors/loading.selector';
import { DialogTypes } from 'src/app/shared/dialog-modal/dialog-types';
import { Utility } from './shared/utility/utility';
import { IAppState } from './store/states/app.state';
import { IFunctionKey } from './models/funtionKey.interface';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  providers: [EnterKeyService],
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'Frontend';
  key: any;
  public dialog = new DialogParams(null, null, null, null, null, null, null, null, null);
  imageSrc = '';
  ngbModalRef: NgbModalRef;
  opening = false;
  idx = 0;
  checkValue = false;
  isLoading = false;
  keyCode: IFunctionKey;
  @ViewChild('dialogModal', { static: true }) dialogModal: ElementRef;
  constructor(
    private dialogModalService: DialogModalService,
    private ngbModal: NgbModal,
    private location: Location,
    private storeApp: Store<IAppState>,
    private util: Utility,
    private store: Store<IFunctionKey>,
  ) {
  }
  ngOnInit(): void {
    this.location.onUrlChange(v => {
      this.subcribeDialogModal();
    });
    this.storeApp.pipe(select(selectedLoading)).subscribe(loading => {
      setTimeout(() => {
        this.isLoading = loading;
      }, 1);
    });
  }
// handler of the keyup event
@HostListener('document:keydown', ['$event'])
onKeyUp(event: KeyboardEvent): void {
  const currEle = event.target as HTMLElement;
  if (event.which === 13 || event.which === 9) {
    if ((event.which === 9 || currEle.tagName !== 'TEXTAREA') && !this.util.checkDialogModalMessage()) {
      event.preventDefault();
      // get list element need auto focus
      let lstInput;
      if ($('ngb-modal-window').length > 0) {
        if ( $('ngb-modal-window').length === 1){
          lstInput = $('ngb-modal-window input, ngb-modal-window select, ngb-modal-window textarea, ngb-modal-window div[class="textarea-custom"],  ngb-modal-window .tab-button-focus');
        }else if ($('.popup-0702').length > 0){
          lstInput = $('#JLAC10Code, #DisplayNamea');
        }
      }
      else if ($('modal-container').length > 0) {
        lstInput = $('modal-container input, modal-container select, modal-container textarea, modal-container div[class="textarea-custom"],  modal-container .tab-button-focus');
      }
      else {
        lstInput = $('input, select, textarea, div[class="textarea-custom"], .tab-button-focus');
      }
      const lstInputNotDisabled = [];
      lstInput.each((idx, item) => {
        if (item.getAttribute('disabled') === null && item.getAttribute('readonly') === null && !item.classList.contains('inp-filter')
        && !item.classList.contains('inp-placeholder')
        ) {
          lstInputNotDisabled.push(item);
        }
        if (item.classList.contains('inp-select-focus') && item.getAttribute('disabled') === null) {
          lstInputNotDisabled.push(item);
        }
      });
      if (lstInputNotDisabled.length > 0) {
        const idxOfCurrEle = lstInputNotDisabled.indexOf(currEle);
        // get next element idx
        if (idxOfCurrEle > -1) {
          if (event.shiftKey) {
            this.idx = idxOfCurrEle === 0 ? lstInputNotDisabled.length - 1 : idxOfCurrEle - 1;
          } else {
            this.idx = idxOfCurrEle === lstInputNotDisabled.length - 1 ? 0 : idxOfCurrEle + 1;
          }
        } else {
          this.idx = event.shiftKey ? lstInputNotDisabled.length - 1 : 0;
        }
        if (this.util.isNullOrEmpty(sessionStorage.getItem('isSelectResCode'))) {
          lstInputNotDisabled[this.idx].focus();
        }
        sessionStorage.removeItem('isSelectResCode');
      }
    }
  }
}
  subcribeDialogModal() {
    this.dialogModalService.modalSubject.subscribe((dialog: DialogParams) => {
      this.dialog = dialog;
      let isBlankObject = true;
      if (this.dialog.type) {
        isBlankObject = false;
      }
      if (!this.opening && !isBlankObject) {
        this.ngbModalRef = this.ngbModal.open(this.dialogModal,
          {
            backdrop: 'static',
            keyboard: false,
            centered: true,
            size: 'modal w500 acist-middle   ' + dialog.colorDialog
          });
        if (this.dialog.type === DialogTypes.success) {
          const timeOut = AppConfigService.settings.timeOutClosePopup;
          this.dialog.type = null;
          this.opening = false;
          setTimeout(() => {
            this.ngbModalRef.close();
          }, timeOut);
        } else {
          this.opening = true;
        }
      }
    });
  }

  closeModal() {
    this.ngbModalRef.close();
    this.dialogModalService.source.next(new DialogParams(null, null, null, null, null, null, null, null, null));
    this.dialog = new DialogParams(null, null, null, null, null, null, null, null, null);
    this.opening = false;
  }

  clickButtonCancel() {
    this.closeModal();
    this.dialogModalService.dialogResult.next(new DialogResult(DialogButtons.cancel));
    this.dialogModalService.dialogResult.complete();
  }

  clickButtonOK() {
    this.closeModal();
    this.dialogModalService.dialogResult.next(new DialogResult(DialogButtons.ok));
    this.dialogModalService.dialogResult.complete();
  }

  clickButtonOKCheckDialog() {
    this.closeModal();
    if (this.checkValue) {
      this.dialogModalService.dialogResult.next(new DialogResult(DialogButtons.ok));
      this.dialogModalService.dialogResult.complete();
    } else {
      this.dialogModalService.dialogResult.next(new DialogResult(DialogButtons.no));
      this.dialogModalService.dialogResult.complete();
    }
  }
  clickButtonNo() {
    this.closeModal();
    this.dialogModalService.dialogResult.next(new DialogResult(DialogButtons.no));
    this.dialogModalService.dialogResult.complete();
  }
}
